import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a89ec7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "ql-formats" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "ql-bold" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "ql-italic" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "ql-underline" }, null, -1))
const _hoisted_6 = {
  class: "ql-header",
  style: {"padding-bottom":"0"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "divider" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "ql-link" }),
  /*#__PURE__*/_createElementVNode("button", { class: "ql-image" })
], -1))
const _hoisted_9 = {
  key: 0,
  class: "wrapper--buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_1 = _resolveComponent("header-1")!
  const _component_icon = _resolveComponent("icon")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Editor, {
      modelValue: $setup.text,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.text) = $event)),
      class: "input p-d-flex p-flex-column-reverse",
      placeholder: $props.placeholder
    }, {
      toolbar: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("button", _hoisted_6, [
            _createVNode(_component_icon, {
              size: 17,
              class: "header-tool",
              strokeColor: 'var(--light-gray)'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_header_1)
              ]),
              _: 1
            }, 8, ["strokeColor"])
          ])
        ]),
        _hoisted_7,
        _hoisted_8
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder"]),
    ($props.buttons)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          ($props.buttons.draft)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                onClick: _cache[1] || (_cache[1] = () => $setup.handleSubmit('draft')),
                disabled: $setup.isTextInvalid,
                class: "button--draft p-button-sm p-mr-2",
                label: $setup.copies.inputPost.saveDraft
              }, null, 8, ["disabled", "label"]))
            : _createCommentVNode("", true),
          ($props.buttons.publish)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                onClick: _cache[2] || (_cache[2] = () => $setup.handleSubmit('publish')),
                disabled: $setup.isTextInvalid,
                class: "button-publish p-button-sm",
                label: $setup.copies.inputPost.publish
              }, null, 8, ["disabled", "label"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}